"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var config_1 = require("./config");
var loadSDK_1 = require("./utils/loadSDK");
/**
 * 多云上传类
 */
var DsCloud = /** @class */ (function () {
    function DsCloud(config, sdk) {
        if (sdk === void 0) { sdk = null; }
        /**
         * 云服务商的SDK文件
         */
        this.sdk = null;
        /**
         * SDK实例对象
         */
        this.client = null;
        this.config = config;
        this.sdk = sdk;
        // this.init()
    }
    /**
     * 初始化
     */
    DsCloud.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            var type, SDK;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        type = this.config.type;
                        return [4 /*yield*/, loadSDK_1.loadSDK(this.sdk, type)];
                    case 1:
                        SDK = _a.sent();
                        if (!SDK) {
                            throw new Error('ds-cloud无法获取SDK文件信息，请检查参数是否正确');
                        }
                        if (config_1.CloudServer[type]) {
                            this.client = config_1.CloudServer[type].initClient(SDK, this.config);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 分片上传
     * @param file 文件对象
     * @param uploadConfig 分段上传的配置参数
     */
    DsCloud.prototype.multipartUpload = function (file, uploadConfig) {
        return __awaiter(this, void 0, void 0, function () {
            var type;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.init()];
                    case 1:
                        _a.sent();
                        type = this.config.type;
                        if (config_1.CloudServer[type]) {
                            return [2 /*return*/, config_1.CloudServer[type].upload(this.client, file, uploadConfig, this.config)];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return DsCloud;
}());
exports.default = DsCloud;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRHNDbG91ZC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9Ec0Nsb3VkLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsbUNBQXNDO0FBRXRDLDJDQUF5QztBQUV6Qzs7R0FFRztBQUNIO0lBQ0UsaUJBQVksTUFBbUIsRUFBRSxHQUFlO1FBQWYsb0JBQUEsRUFBQSxVQUFlO1FBTWhEOztXQUVHO1FBQ0gsUUFBRyxHQUFRLElBQUksQ0FBQTtRQU9mOztXQUVHO1FBQ0gsV0FBTSxHQUFRLElBQUksQ0FBQTtRQWxCaEIsSUFBSSxDQUFDLE1BQU0sR0FBRyxNQUFNLENBQUE7UUFDcEIsSUFBSSxDQUFDLEdBQUcsR0FBRyxHQUFHLENBQUE7UUFDZCxjQUFjO0lBQ2hCLENBQUM7SUFpQkQ7O09BRUc7SUFDRyxzQkFBSSxHQUFWOzs7Ozs7d0JBRVUsSUFBSSxHQUFLLElBQUksQ0FBQyxNQUFNLEtBQWhCLENBQWdCO3dCQUVoQixxQkFBTSxpQkFBTyxDQUFDLElBQUksQ0FBQyxHQUFHLEVBQUUsSUFBSSxDQUFDLEVBQUE7O3dCQUFuQyxHQUFHLEdBQUcsU0FBNkI7d0JBRXpDLElBQUksQ0FBQyxHQUFHLEVBQUU7NEJBQ1IsTUFBTSxJQUFJLEtBQUssQ0FBQywrQkFBK0IsQ0FBQyxDQUFBO3lCQUNqRDt3QkFFRCxJQUFJLG9CQUFXLENBQUMsSUFBSSxDQUFDLEVBQUU7NEJBQ3JCLElBQUksQ0FBQyxNQUFNLEdBQUcsb0JBQVcsQ0FBQyxJQUFJLENBQUMsQ0FBQyxVQUFVLENBQUMsR0FBRyxFQUFFLElBQUksQ0FBQyxNQUFNLENBQUMsQ0FBQTt5QkFDN0Q7Ozs7O0tBQ0Y7SUFFRDs7OztPQUlHO0lBQ0csaUNBQWUsR0FBckIsVUFBc0IsSUFBVSxFQUFFLFlBQW1DOzs7Ozs0QkFDbkUscUJBQU0sSUFBSSxDQUFDLElBQUksRUFBRSxFQUFBOzt3QkFBakIsU0FBaUIsQ0FBQTt3QkFDVCxJQUFJLEdBQUssSUFBSSxDQUFDLE1BQU0sS0FBaEIsQ0FBZ0I7d0JBRTVCLElBQUksb0JBQVcsQ0FBQyxJQUFJLENBQUMsRUFBRTs0QkFDckIsc0JBQU8sb0JBQVcsQ0FBQyxJQUFJLENBQUMsQ0FBQyxNQUFNLENBQUMsSUFBSSxDQUFDLE1BQU0sRUFBRSxJQUFJLEVBQUUsWUFBWSxFQUFFLElBQUksQ0FBQyxNQUFNLENBQUMsRUFBQTt5QkFDOUU7Ozs7O0tBQ0Y7SUFDSCxjQUFDO0FBQUQsQ0FBQyxBQXJERCxJQXFEQyJ9